<template>
  <section class="p-2">
    <v-card>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <v-card-text class="pb-2">
        <v-card class="pa-2 bord-color" elevation="0" rounded outlined>
          <v-sheet
            class="v-sheet--offset ms-4 pt-1 text-center"
            elevation="0"
            outlined
            width="90px"
          >
            <p class="font-weight-bold">
              <v-icon small class="me-1" color="secondary">mdi-filter</v-icon
              >Filters
            </p>
          </v-sheet>
          <p class="pl-4">
            Please provide specific transaction pin number and click on "Get
            Transaction".
          </p>
          <v-form ref="form" v-model="valid">
            <v-row class="ms-1 me-1">
              <v-col cols="12" md="2" lg="2" xs="12">
                <label class="my-0 rounded labelFontsize required">
                  Pin Number
                </label>
                <v-text-field
                  placeholder="Enter Pin Number"
                  v-model="transpinNumber"
                  outlined
                  :rules="FieldRequired('Pin Number')"
                  dense
                  required
                  class="rounded"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2" lg="2" xs="12">
                <label class="my-0 rounded labelFontsize">
                  Transaction Id
                </label>
                <v-text-field
                  v-model="txn_id"
                  placeholder="Enter Transaction Id"
                  outlined
                  dense
                  required
                  class="rounded"
                ></v-text-field>
              </v-col>

              <div class="d-flex mt-1">
                <v-btn
                  depressed
                  small
                  class="text-capitalize py-4 mt-5"
                  color="primary"
                  @click="gettxnbyId()"
                  dense
                  >Get Transaction Status</v-btn
                >
              </div>
            </v-row>
          </v-form>
        </v-card>
      </v-card-text>

      <v-row no-gutters v-if="hideTransDetails">
        <v-col cols="12" md="6" class="pe-2">
          <div class="ms-4">
            <v-toolbar color="#ffeee1" flat dense>
              <span
                >Transaction Info :- {{ transactionList.transaction_id }}</span
              ><span v-if="showChip"
                ><v-chip
                  class="ma-2"
                  small
                  :color="returnColor(transactionList.status)"
                  label
                >
                  {{ transactionList.status }}
                </v-chip></span
              >
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-simple-table dense class="ma-3">
              <tbody>
                <tr>
                  <td>Channel Partner</td>
                  <td>
                    <span class="font-weight-bold">{{
                      transactionList.parent_coll_sub_agent_cd
                    }}</span>
                  </td>
                </tr>
                <tr>
                  <td class="">Sender Name</td>
                  <td class="font-weight-bold">
                    {{ transactionList.sender_name }}
                  </td>
                </tr>
                <tr>
                  <td>Beneficiary Name</td>
                  <td class="font-weight-bold">
                    {{ transactionList.beneficiary_name }}
                  </td>
                </tr>
                <tr>
                  <td>Transaction Date</td>
                  <td class="font-weight-bold">
                    {{ transactionList.send_date }}
                  </td>
                </tr>
                <tr>
                  <td>Beneficiary Country</td>
                  <td class="font-weight-bold">
                    {{ transactionList.country }}
                  </td>
                </tr>
                <tr>
                  <td>Payout Amount</td>
                  <td class="font-weight-bold">
                    <span class="font-weight-bold">
                      {{ transactionList.amount_sent }}</span
                    >
                  </td>
                </tr>
                <tr>
                  <td>Collected Amount</td>
                  <td class="font-weight-bold">
                    <span class="font-weight-bold">
                      {{ transactionList.receiving_amount }}</span
                    >
                  </td>
                </tr>

                <tr>
                  <td>Payment Mode</td>
                  <td class="font-weight-bold">
                    <span class="font-weight-bold">
                      {{ transactionList.mode_of_payment }}</span
                    >
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </div>
        </v-col>
        <v-col cols="12" md="6" class="pe-2">
          <div class="ms-4">
            <v-toolbar color="#ffeee1" flat dense>
              <span>Partner Info :- {{ transactionList.transaction_id }}</span>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-simple-table dense class="ma-3">
              <tbody>
                <tr>
                  <td>Partner Pin Number</td>
                  <td>
                    <span class="font-weight-bold">{{
                      transactionList.partner_pinnumber
                    }}</span>
                  </td>
                </tr>
                <tr>
                  <td class="">Partner Agent Pin Number</td>
                  <td class="font-weight-bold">
                    {{ transactionList.partner_agent_pinnumber }}
                  </td>
                </tr>
                <tr>
                  <td>Partner Code</td>
                  <td class="font-weight-bold">
                    {{ transactionList.partner_code }}
                  </td>
                </tr>
                <tr>
                  <td>Partner Message</td>
                  <td class="font-weight-bold">
                    {{ transactionList.partner_message }}
                  </td>
                </tr>
                <tr>
                  <td>Partner Status</td>
                  <td class="font-weight-bold">
                    {{ transactionList.partner_status }}
                  </td>
                </tr>
                <tr>
                  <td>Partner Transaction Date</td>
                  <td class="font-weight-bold">
                    <span class="font-weight-bold">
                      {{ transactionList.partner_txndate }}</span
                    >
                  </td>
                </tr>
                <tr>
                  <td>Partner Confirm Id</td>
                  <td class="font-weight-bold">
                    <span class="font-weight-bold">
                      {{ transactionList.partner_confirmid }}</span
                    >
                  </td>
                </tr>

                <tr>
                  <td>Partner Is Comitted</td>
                  <td class="font-weight-bold">
                    <span class="font-weight-bold">
                      {{ transactionList.partner_is_comitted }}</span
                    >
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </div>
        </v-col>
      </v-row>
    </v-card>
  </section>
</template>
<script>
import PaymentService from "@/services/PaymentService/paymentService.js";
import alerts from "@/mixins/alerts";
import { FieldRequired } from "@/utils/validation.js";
import croneService from "@/services/CroneService/croneService.js";

export default {
  mixins: [alerts],
  name: "AP",
  components: {
    // OverlayPageVue,
  },
  data: () => {
    return {
      FieldRequired,
      pin_number: "",
      status: "",

      updateStatusDialog: false,
      datapin_number: null,
      transactionList: [],
      transpinNumber: "",
      isloadagents: false,
      showChip: false,
      hideTransDetails: false,
      txn_id: null,
    };
  },

  methods: {
    returnColor(status) {
      if (status == "Paid") {
        return "success";
      } else if (status == "Cancel") {
        return "error";
      } else if (status == "Hold") {
        return "orange";
      } else if (status == "Pending") {
        return "yellow";
      } else {
        return "primary";
      }
    },
    async getFilterTransaction() {
      this.isloadagents = true;
      this.hideTransDetails = true;
      try {
        const responseData = await PaymentService.getTransPartnerStatus(
          this.pin_number,
        );
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.transactionList = responseData.data.data[0];
          this.datapin_number = responseData.data.data[0].transaction_id;
          this.showChip = true;
          console.log("  this.transactionList", this.transactionList);
        } else {
          this.showAlertError(`Error: ${responseData.data.message}`);
        }
      } catch (e) {
        console.error(e);
        this.isloadagents = false;
      }
    },

    async gettxnbyId() {
      if (this.$refs.form.validate()) {
        this.$emit("showOverlay", true);
        try {
          const responseData = await croneService.getTransPinStatus(
            this.transpinNumber,
            this.txn_id,
          );
          if (responseData.data.status_code === 200) {
            this.$emit("showOverlay", false);
            // this.$refs.form.reset();
            this.pin_number =
              responseData.data.data[0].data[0].partner_transaction_id;
            console.log("this.pin_number", this.pin_number);
            this.getFilterTransaction();
          } else {
            this.$emit("showOverlay", false);
            this.showAlertError(
              `Fetching Transaction Status :${
                responseData?.data?.message
                  ? responseData?.data?.message
                  : "Failed"
              }`,
            );
          }
          return responseData.data?.data;
        } catch (e) {
          this.$emit("showOverlay", false);
          console.log(e);
        }
      }
    },
  },
};
</script>
<style>
.required:after {
  content: " *";
  color: red;
}
.v-sheet--offset {
  top: -20px;
  width: 100px;
  height: 30px;
  position: relative;
  border-radius: 5px;
}
.bord-color {
  border-radius: 10px;
}
th,
td {
  border-bottom: 1px solid rgb(231, 229, 229);
  border-collapse: collapse;
  padding: 5px;
}
</style>
